






import {Component, Vue} from 'vue-property-decorator';
import {Getter} from 'vuex-class';
import {AUTH_GET_CLIENT, AUTH_GET_COUNTRY, AUTH_GET_VEHICLETYPE} from '@/store/modules/authentication/types';
import {Client} from '@/store/modules/authentication/interfaces';

import {traceLogAccess} from '@/services';
import {ContextEnum} from '@/enums/context.enum';
import {ClientEnum} from '@/enums/client.enum';
import {TupleDictionary} from '@/utils/tupleDictionary';

import ReportPowerBiContainer from '../../components/report-powerbi-container/report-powerbi-container.vue';
import {CountryEnum, CountryType} from '@/enums/country.enum';
import PbiDictWorkspaceId, { PbiWorkspacesEnum } from '@/modules/neodash/containers/powerbi/pbi-dict-workspace-id';
import {VehicleTypeEnum} from '@/enums/vehicle-type.enum';

@Component({
  name: 'PbiSouthAmericaPage',
  components: { ReportPowerBiContainer }
})

export default class PbiSouthAmericaPage extends Vue {
  @Getter(AUTH_GET_CLIENT)
  public client: Client;

  @Getter(AUTH_GET_COUNTRY)
  public country: CountryType;

  @Getter(AUTH_GET_VEHICLETYPE)
  public idVehicleType: number;

  private pbiDictWorkspaceId = new PbiDictWorkspaceId();

  public dictReports = new TupleDictionary<[ClientEnum, VehicleTypeEnum, CountryType], IPbiContainer>();
  public crrReport: IPbiContainer = { brand: '', workspaceId: '', reportId: '' };

  mounted() {
    // Brasil
    this.dictReports.set([ClientEnum.GM, VehicleTypeEnum.Car, CountryEnum.Brasil], { brand: 'GM', workspaceId: this.pbiDictWorkspaceId.dictionary.get([PbiWorkspacesEnum.Neodash]), reportId: 'c6279dda-9b53-4c2b-99b3-849b990a8f3b' });
    this.dictReports.set([ClientEnum.Fiat, VehicleTypeEnum.Car, CountryEnum.Brasil], { brand: 'Fiat', workspaceId: this.pbiDictWorkspaceId.dictionary.get([PbiWorkspacesEnum.Neodash]), reportId: 'e65f1c02-e1d7-44b9-bf60-85b3c9d0f171' });

    // Peru
    this.dictReports.set([ClientEnum.GM, VehicleTypeEnum.Car, CountryEnum.Peru], { brand: 'GM', workspaceId: this.pbiDictWorkspaceId.dictionary.get([PbiWorkspacesEnum.Neodash]), reportId: 'c6279dda-9b53-4c2b-99b3-849b990a8f3b' });
    this.dictReports.set([ClientEnum.Volkswagen, VehicleTypeEnum.Car, CountryEnum.Peru], { brand: 'Volkswagen', workspaceId: this.pbiDictWorkspaceId.dictionary.get([PbiWorkspacesEnum.Neodash]), reportId: 'e6300180-3672-437c-b1a5-857d96cfe76b' });

    // Colômbia
    this.dictReports.set([ClientEnum.GM, VehicleTypeEnum.Car, CountryEnum.Colombia], { brand: 'GM', workspaceId: this.pbiDictWorkspaceId.dictionary.get([PbiWorkspacesEnum.Neodash]), reportId: 'c6279dda-9b53-4c2b-99b3-849b990a8f3b' });
    this.dictReports.set([ClientEnum.Hyundai, VehicleTypeEnum.Car, CountryEnum.Colombia], { brand: 'Hyundai', workspaceId: this.pbiDictWorkspaceId.dictionary.get([PbiWorkspacesEnum.Neodash]), reportId: '0a942aa0-80ba-457f-9339-298bbf9a674f' });
    this.dictReports.set([ClientEnum.Volkswagen, VehicleTypeEnum.Car, CountryEnum.Colombia], { brand: 'Volkswagen', workspaceId: this.pbiDictWorkspaceId.dictionary.get([PbiWorkspacesEnum.Neodash]), reportId: 'e6300180-3672-437c-b1a5-857d96cfe76b' });

    // Chile
    this.dictReports.set([ClientEnum.GM, VehicleTypeEnum.Car, CountryEnum.Chile], { brand: 'GM', workspaceId: this.pbiDictWorkspaceId.dictionary.get([PbiWorkspacesEnum.Neodash]), reportId: 'c6279dda-9b53-4c2b-99b3-849b990a8f3b' });
    this.dictReports.set([ClientEnum.Volkswagen, VehicleTypeEnum.Car, CountryEnum.Chile], { brand: 'Volkswagen', workspaceId: this.pbiDictWorkspaceId.dictionary.get([PbiWorkspacesEnum.Neodash]), reportId: 'e6300180-3672-437c-b1a5-857d96cfe76b' });

    // Equador
    this.dictReports.set([ClientEnum.GM, VehicleTypeEnum.Car, CountryEnum.Equador], { brand: 'GM', workspaceId: this.pbiDictWorkspaceId.dictionary.get([PbiWorkspacesEnum.Neodash]), reportId: 'c6279dda-9b53-4c2b-99b3-849b990a8f3b' });
    this.dictReports.set([ClientEnum.Hyundai, VehicleTypeEnum.Car, CountryEnum.Equador], { brand: 'Hyundai', workspaceId: this.pbiDictWorkspaceId.dictionary.get([PbiWorkspacesEnum.Neodash]), reportId: '0a942aa0-80ba-457f-9339-298bbf9a674f' });
    this.dictReports.set([ClientEnum.Volkswagen, VehicleTypeEnum.Car, CountryEnum.Equador], { brand: 'Volkswagen', workspaceId: this.pbiDictWorkspaceId.dictionary.get([PbiWorkspacesEnum.Neodash]), reportId: 'e6300180-3672-437c-b1a5-857d96cfe76b' });

    // Argentina
    this.dictReports.set([ClientEnum.GM, VehicleTypeEnum.Car, CountryEnum.Argentina], { brand: 'GM', workspaceId: this.pbiDictWorkspaceId.dictionary.get([PbiWorkspacesEnum.Neodash]), reportId: 'c6279dda-9b53-4c2b-99b3-849b990a8f3b' });
    this.dictReports.set([ClientEnum.Volkswagen, VehicleTypeEnum.Car, CountryEnum.Argentina], { brand: 'Volkswagen', workspaceId: this.pbiDictWorkspaceId.dictionary.get([PbiWorkspacesEnum.Neodash]), reportId: 'e6300180-3672-437c-b1a5-857d96cfe76b' });

    // Uruguai
    this.dictReports.set([ClientEnum.Hyundai, VehicleTypeEnum.Car, CountryEnum.Uruguai], { brand: 'Hyundai', workspaceId: this.pbiDictWorkspaceId.dictionary.get([PbiWorkspacesEnum.Neodash]), reportId: '0a942aa0-80ba-457f-9339-298bbf9a674f' });
    this.dictReports.set([ClientEnum.Volkswagen, VehicleTypeEnum.Car, CountryEnum.Uruguai], { brand: 'Volkswagen', workspaceId: this.pbiDictWorkspaceId.dictionary.get([PbiWorkspacesEnum.Neodash]), reportId: 'e6300180-3672-437c-b1a5-857d96cfe76b' });

    this.crrReport = this.dictReports.get([this.client.id, this.idVehicleType, this.country]);
    traceLogAccess.logAction(ContextEnum.Report, `${this.crrReport.brand} - Market Diagnosis`);
  }
}
